import { StyleSheet, Text, View } from '@react-pdf/renderer';

export default function EuropassPdfFooter() {
    const styles = StyleSheet.create( {
        footer: {
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            marginRight: 40
        },
    } );

    return (
        <View style={ [ styles.footer, { marginTop: 0, height: 30 } ] } fixed>
            <View style={ {
                flex: 1,
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                paddingRight: 20,
                paddingBottom: 5
            } }>
                <Text style={ { fontSize: 8, color: "#000000" } } render={ ( { pageNumber, totalPages } ) => (
                    `${ pageNumber } / ${ totalPages }`
                ) }/>
            </View>
        </View>
    );
}
